import React, { useState, useContext, useRef, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { AuthContext } from "../../comum/Context/auth.jsx";
import { api } from "../../services/api.js";

import { setLoginToday } from "./../Utils/auth.js";

import logoSmall from "../../comum/assets/arbor.png";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import SentimentoPopup from "../Components/Sentimento/SentimentoPopup.jsx";


import "./index.css";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const senhaRef = useRef(null); // 🔹 referência para campo senha
  const inputRef = useRef(null);

  const { setLogado } = useContext(AuthContext);

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [msgerro, setmsgErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [mostrarSentimento, setMostrarSentimento] = useState(false);

  const [cacheForcado, setCacheForcado] = useState(false);

  const [chapaUsuario, setChapaUsuario] = useState(null);
  const [eyesIsClosed, setEyeState] = useState(false);

  const emailRef = useRef(null); // 🔹 referência para o campo de matrícula

  useEffect(() => {
    emailRef.current?.focus(); // 🔹 foca no input assim que a página carregar
  }, []);


  const redirectTo =
    new URLSearchParams(location.search).get("redirect") || "/arbor/home";

  const toggleShow = () => {
    if (inputRef.current) {
      const isPassword = inputRef.current.type === "password";
      inputRef.current.type = isPassword ? "text" : "password";
      setEyeState(!isPassword);
    }
  };

  const LoginArbor = () => {
    setLogado(false);
    localStorage.clear();
    const data = { usuario: email, senha, versao: "1.2" };

    api
      .post("/usuario/consultausuario/web", data)
      .then((retorno) => {
        const res = retorno.data;
        setSucesso(res.SUCESSO);
        setmsgErro(res.ERRO);
        const lojap = res.LOJA;
        console.log('Dados do usuario');
        console.log(lojap);
        console.log(res.LOJA);


        if (res.SUCESSO === "S") {
          // validação do PONTO
          const temPermissaoPonto = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "RHEXCLUSIVO" &&
              p.usrconf_campo === "RHEXVPONTOAUTORIZA" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("permitePonto", temPermissaoPonto ? "S" : "N");

          const temPermissaoRegional = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "RHEXCLUSIVO" &&
              p.usrconf_campo === "RHEXVCOMUNICADOREG" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("permiteRegional", temPermissaoRegional ? "S" : "N");

          const temPermissaoDiretor = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "CARGO" &&
              p.usrconf_campo === "DIRETOR" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("diretor", temPermissaoDiretor ? "S" : "N");

          const temPermissaoSap = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "SAP" &&
              p.usrconf_campo === "SAPADMIN" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("SAPADM", temPermissaoSap ? "S" : "N");

          //checklist TI
          const temCadastroCheckListti = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "TICHECKCADASTRO" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("TICADCHECKLIST", temCadastroCheckListti ? "S" : "N");

          const TemVistoria = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "VISTORIA" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("vistoriaLoja", TemVistoria ? "S" : "N");


          const ConsultaFerias = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "FERIAS" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("FERIAS", ConsultaFerias ? "S" : "N");

          //checklist TI
          const temConciliaCartao = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "CONCILIACARTAO" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("CONCILIACARTAO", temConciliaCartao ? "S" : "N");

          //DashBoard RH
          const permiteDashBoardRH = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "FLOSOFTNEW" &&
              p.usrconf_campo === "RH" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("RHDASHBOARD", permiteDashBoardRH ? "S" : "N");


          const temCheckList = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "CHECKLIST" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("CHECKLIST", temCheckList ? "S" : "N");
          // 🔹 Montagem das lojas permitidas
          let lojasPermitidas = res.LOJAS || [];

          const permiteVendas = res.PROGRAMAS?.some(
            (p) =>
              p.usrconf_modulo === "MOBILE" &&
              p.usrconf_campo === "VENDAS" &&
              p.usrconf_acesso === "S"
          );
          localStorage.setItem("permiteVendas", permiteVendas ? "S" : "N");


          //PERMISSÃO DE CHAMADO
          {/*const acessosSetor = res.PROGRAMAS
            ?.filter(p => p.usrconf_modulo === "CHAMADO" && p.usrconf_campo === "SETOR")
            .map(p => p.usrconf_acesso); // Retorna algo como ["1", "2"]

          // Salva no localStorage como String (JSON)
          localStorage.setItem("setorchamado", JSON.stringify(acessosSetor));*/}

          const acessosSetorRaw = res.PROGRAMAS
            ?.filter(p => p.usrconf_modulo === "CHAMADO" && p.usrconf_campo === "SETOR")
            .map(p => p.usrconf_acesso); // Retorna ["1,2,3"]
          console.log(acessosSetorRaw);
          // Transforma ["1,2,3"] em ["1", "2", "3"]
          const acessosSetor = acessosSetorRaw && acessosSetorRaw.length > 0
            ? acessosSetorRaw[0].split(',')
            : [];
          console.log(acessosSetor);
          // Salva no localStorage como String (JSON) ["1", "2", "3"]
          localStorage.setItem("setorchamado", JSON.stringify(acessosSetor));



          // ===============================
          // 🔹 BUSCAR LOJAS (VERSÃO AJUSTADA)
          // ===============================

          // Loja vinda do backend
          const lojaBackend = res.LOJA || res.lojap;

          // Loja do PROGRAMAS
          const lojaPri = res.PROGRAMAS?.find(
            (p) =>
              p.usrconf_modulo === "USRLOJA" &&
              p.usrconf_campo === "NUMLOJA"
          );

          // 🔹 Define loja principal com prioridade
          let lojaPrincipal = null;

          if (lojaPri?.usrconf_acesso) {
            const parsed = parseInt(lojaPri.usrconf_acesso, 10);
            if (!isNaN(parsed)) lojaPrincipal = parsed;
          }

          if (lojaPrincipal === null && lojaBackend) {
            const parsed = parseInt(lojaBackend, 10);
            if (!isNaN(parsed)) lojaPrincipal = parsed;
          }

          // 🔹 Salva loja principal
          if (lojaPrincipal !== null) {
            const lojaFormatada = String(lojaPrincipal).padStart(2, "0");
            localStorage.setItem("lojaprincipal", lojaFormatada);
            console.log("Loja Principal:", lojaFormatada);
          } else {
            console.warn("Nenhuma loja principal válida encontrada.");
          }

          // ===============================
          // 🔹 MONTA LISTA DE LOJAS
          // ===============================

          let lojasPermitidasFinal = Array.isArray(lojasPermitidas)
            ? [...lojasPermitidas]
            : [];

          // Se não veio lojas → tenta PROGRAMAS
          if (lojasPermitidasFinal.length === 0 && lojaPri?.usrconf_acesso) {
            const parsed = parseInt(lojaPri.usrconf_acesso, 10);
            if (!isNaN(parsed)) {
              lojasPermitidasFinal = [parsed];
            }
          }

          // Se ainda vazio → usa loja principal
          if (lojasPermitidasFinal.length === 0 && lojaPrincipal !== null) {
            lojasPermitidasFinal = [lojaPrincipal];
          }

          // 🔹 Normaliza (garante padrão 01, 02, etc)
          lojasPermitidasFinal = lojasPermitidasFinal
            .filter((l) => !isNaN(l))
            .map((l) => String(l).padStart(2, "0"))
            .sort((a, b) => parseInt(a) - parseInt(b));

          // 🔹 Salva lista
          localStorage.setItem(
            "lojasPermitidas",
            JSON.stringify(lojasPermitidasFinal)
          );

          // ===============================
          // 🔹 DEFINE LOJA SELECIONADA
          // ===============================

          const lojaSelecionada =
            lojaPrincipal !== null
              ? String(lojaPrincipal).padStart(2, "0")
              : lojasPermitidasFinal[0] || null;

          if (lojaSelecionada) {
            localStorage.setItem("loja", lojaSelecionada);
            localStorage.setItem("lojaSelecionada", lojaSelecionada);
          }

          localStorage.setItem(
            "pontoAutorizado",
            temPermissaoPonto ? "S" : "N"
          );

          // 🔹 Salvar apenas dados essenciais do usuário
          /*const usuarioInfo = {
            usuario: res.USUARIO,
            nome: res.NOME,
            lojaSelecionada,
            lojasPermitidas,
            permitePonto: temPermissaoPonto ? "S" : "N",
            sapAdm: temPermissaoSap ? "S" : "N",
          };
          localStorage.setItem("usuarioInfo", JSON.stringify(usuarioInfo));*/
          localStorage.setItem("usuarioInfo", JSON.stringify(res));

          // 🔹 Restante do fluxo
          setLoginToday(data.usuario, lojaSelecionada, res.SAP, null);
          localStorage.removeItem("codigorest");
          setChapaUsuario(data.usuario);
          setLogado(true);


          localStorage.setItem("sentido", res.SENTIMENTO);
          localStorage.setItem("msg", res.MENSAGENS);
          if (res.SENTIMENTO === "0") {
            setMostrarSentimento(true);
          }
        } else {
          localStorage.setItem("logado", "N");
          localStorage.setItem("acessoSAP", "N");
          setLogado(false);
        }
      })
      .catch((err) => {
        console.error("Erro de login:", err);
        localStorage.setItem("logado", "N");
        localStorage.setItem("acessoSAP", "N");
        setLogado(false);
        setSucesso("N");
        setmsgErro("Erro de comunicação com o servidor");
      });
  };

  useEffect(() => {
    if (sucesso === "S" && !mostrarSentimento) {
      if (chapaUsuario?.startsWith("900010")) {
        navigate("/arbor/home/");
      } else if (chapaUsuario?.startsWith("900001")) {
        navigate("/arbor/home/");
      } else if (chapaUsuario?.startsWith("90")) {
        navigate("/arbor/restaurante/");
      } else {
        navigate("/arbor/home/");
      }
    }
  }, [sucesso, mostrarSentimento, redirectTo, navigate, chapaUsuario]);

  return (
    <div>
      <Menu modulo="login" />

      <div className="d-flex align-items-center text-center form-container">
        <form className="form-signin" onSubmit={(e) => e.preventDefault()}>
          <img className="mb-4 img-login" src={logoSmall} alt="Arbor" />
          <h1 className="h3 mb-3 fw-normal">Login</h1>

          <div className="form-floating">
            <input
              type="number"
              id="floatingInput"
              className="form-control"
              placeholder="Matrícula"
              value={email}
              ref={emailRef}               // 🔹 aplica a ref
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  senhaRef.current?.focus(); // 🔹 foca no campo senha
                }
              }}
            />
            <label htmlFor="floatingInput">Matrícula</label>
          </div>

          <div className="form-floating">
            <input
              type="password"
              id="floatingPassword"
              className="form-control"
              placeholder="Senha"
              ref={senhaRef} // 🔹 referência do campo senha
              onChange={(e) => setSenha(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && email !== "") {
                  e.preventDefault();
                  LoginArbor();
                }
              }}
            />
            <label htmlFor="floatingPassword">Senha</label>
          </div>

          <button
            type="button"
            className="w-100 btn btn-lg btn-success"
            onClick={LoginArbor}
          >
            Acessar
          </button>

          {sucesso === "N" && (
            <div className="alert alert-danger mt-2" role="alert">
              {msgerro}.
            </div>
          )}

          <div className="mt-3">
            <Link to="/arbor/esqueci-senha" style={{ textDecoration: 'none', color: '#198754', fontWeight: 'bold' }}>
              Esqueci Senha / Cadastrar
            </Link>
          </div>

          <p className="mt-5 mb-3 text-muted">
            &copy; Desenvolvido por F2 Enterprise
          </p>
        </form>
      </div>

      {mostrarSentimento && (
        <SentimentoPopup
          chapa={chapaUsuario}
          onClose={() => setMostrarSentimento(false)}
        />
      )}

      <Footer />
    </div>
  );
}

export default Login;
